// extracted by mini-css-extract-plugin
export default {"main":"MainParagraphs_main__7sKbs","scroll":"MainParagraphs_scroll__1FBTq","animate1":"MainParagraphs_animate1__Rxmrr"};